import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bulletin-edit",
  "use": "icon-bulletin-edit-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-bulletin-edit\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path fill=\"currentColor\" d=\"M8 2v2H4v8h8V8h2v6H2V2h6zm5.182-.096 1.414 1.414-6.07 6.071H7.11V7.975l6.071-6.071z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol